import React, { FC } from 'react'
import { MoonLoader } from 'react-spinners'
import { useTheme } from 'styled-components'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import TitleDescription, { TitleDescriptionProps } from '../../components/TitleDescription'

import * as SC from './styled'

export type HomeTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  titleDescription?: TitleDescriptionProps
  loading?: boolean
}

const HomeTemplate: FC<HomeTemplateProps> = (props) => {
  const { layout, titleDescription, loading = true } = props

  const theme = useTheme()

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        {titleDescription && <TitleDescription {...titleDescription} />}
        {loading && <MoonLoader color={theme.colors.pureBlack} size={28} />}
      </SC.Content>
    </DefaultLayout>
  )
}

export default HomeTemplate
